import { type UserMeTenantPartnerExEntity } from '@/libs/api'

/**
 * パートナーユーザーの右上に出す表示名「パートナー名 / 事業所名」を組み立てる (VOC_PJ-1107 / #6012)。
 * 事業所名が未設定のパートナーは、事業所の位置に「-」を出す。
 */
export const buildPartnerDisplayName = (
  partner: Pick<UserMeTenantPartnerExEntity, 'name' | 'officeName'>
): string => {
  const officeName = partner.officeName?.trim() ? partner.officeName : '-'
  return `${partner.name} / ${officeName}`
}
